var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loadingMroe",staticClass:"loading-more",on:{"click":_vm._loadingMore}},[(_vm.loading)?_c('p',[_vm._m(0),_vm._v(" 努力加载中 ")]):_c('p',[_vm._v(" 点击加载更多 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-block loading-animate"},[_c('i',{staticClass:"loading-more-icon"})])
}]

export { render, staticRenderFns }